// extracted by mini-css-extract-plugin
module.exports = {"container":"builder-container_container__W55NJ","section":"builder-container_section__LxmoK","content":"builder-container_content__gj4uo","title":"builder-container_title__hCUDG"};